import { Component, inject } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { TimezoneOnboardingStore } from '../store/timezone-onboarding.store';
import { VendorDateTimeService } from 'src/app/core/service/vendor-datetime.service';
import { ButtonFillComponent } from '../button-fill/button-fill.component';


@Component({
  selector: 'app-timezone-completion-alert-popup',
  standalone: true,
  imports: [ModalComponent, ButtonFillComponent],
  templateUrl: './timezone-completion-alert-popup.component.html',
  styleUrl: './timezone-completion-alert-popup.component.css',
})
export class TimezoneCompletionAlertPopupComponent {
  private readonly timezoneStore = inject(TimezoneOnboardingStore);
  private readonly vendorDateTimeService = inject(VendorDateTimeService);

  get isModalOpen(): boolean {
    return this.timezoneStore.isOpen() && this.vendorDateTimeService.isTimeZoneMissing();
  }
  onSetTimezone(): void {
    this.timezoneStore.close();
  }
}
